import {h, Component} from 'preact';
import { CreatePasswordInput } from '@webapp/preact-shared';
import ChangePasswordService from '../../services/changePasswordService';

export default class UpdateOldPassword extends Component {
    constructor() {
        super();
        this.state = {
            oldPassword: '',
            isGoodPassword: false,
            passwordError: '',
            changePasswordLoading: false,
            onVerifyAgain: false
        }
    }

    onOldPasswordInput = e => {
        const oldPassword = e.target.value;
        this.setState({ oldPassword });
    };

    setPasswordValidation = isGoodPassword => {
        this.setState({ isGoodPassword });
    };

    changePassword = () => {
        if (!this.state.oldPassword) {
            return;
        }
        if (this.state.changePasswordLoading) {
            console.log('Loading...');
        } else {
            const newPassword = this.props.getPassword();
            this.setState({ changePasswordLoading: true, passwordError: '' });
            ChangePasswordService.checkIsPasswordProhibited(newPassword)
                .then(({data}) => {
                    if (data) {
                        this.setState({
                            changePasswordLoading: false,
                            passwordError: 'The password is prohibited, please try a new one.'
                        });
                    } else {
                        ChangePasswordService.updatePassword(this.state.oldPassword, newPassword)
                            .then(() => {
                                this.setState({ changePasswordLoading: false, passwordError: '' });
                                this.props.setStep('passwordUpdated');
                            }, error => {
                                this.setState({
                                    changePasswordLoading: false,
                                    passwordError: 'Server error, please try later.'
                                });
                            });
                    }
                }, error => {
                    if (error.response.status === 401) {
                        this.props.history.push({
                            pathname: '/',
                            search: location.search,
                            state: { from: this.props.location.pathname }
                        })
                    }
                });
        }
    };

    render({setPassword}, {oldPassword, isGoodPassword, passwordError, changePasswordLoading, onVerifyAgain}) {
        return(
            <div className='form'>
                <h2>Change your Workplace password</h2>
                <div className='create-new-password clearfix'>
                    <div className='old-password-field'>
                        <h4>Enter your old password:</h4>
                        <input type='password'
                               className='form-control'
                               id='old-password-field'
                               value={oldPassword}
                               onInput={this.onOldPasswordInput}
                        />
                    </div>
                    <CreatePasswordInput setPassword={setPassword}
                                         passwordError={passwordError}
                                         action={this.changePassword}
                                         setPasswordValidation={this.setPasswordValidation}
                                         minLength={9}
                    />
                    <div className='bottom-buttons clearfix'>
                        <a className={`button-prime button pull-right ${oldPassword && isGoodPassword ? '' : 'disabled'} ${changePasswordLoading ? 'loading' : ''}`}
                           onClick={this.changePassword}>
                            Change password
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/scripts/views/change-password/update-old-password.js